var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("view-page", {
    attrs: {
      title: _vm.pageTitle,
      "permission-name": "asset_reservation_management",
      "edit-button": false,
      "delete-button": false,
      loading: _vm.loading,
      "loading-text": ""
    },
    scopedSlots: _vm._u([
      {
        key: "leftSide",
        fn: function() {
          return _vm._l(_vm.fields, function(field) {
            return !_vm.loading && _vm.fields.length > 0
              ? _c("view-page-data-field", {
                  key: field.label,
                  attrs: {
                    icon: field.icon,
                    label: field.label,
                    data: field.data
                  }
                })
              : _vm._e()
          })
        },
        proxy: true
      },
      {
        key: "headerRightSide",
        fn: function() {
          return [
            _c("management-tabs-and-search", {
              attrs: { tabs: _vm.tabs, "open-tab": _vm.openTab },
              on: {
                "update-open-tab": function($event) {
                  _vm.openTab = $event
                }
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "rightSide",
        fn: function() {
          return [
            _c(
              "v-tabs-items",
              { attrs: { value: _vm.openTab } },
              [
                _c(
                  "v-tab-item",
                  { attrs: { value: "map" } },
                  [
                    _c("reservation-details-map", {
                      attrs: {
                        "asset-reservation-uuid": _vm.assetReservation.ar_uuid,
                        "asset-reservation-geo-json":
                          _vm.assetReservation.ar_geo_json,
                        "asset-reservation-objects":
                          _vm.assetReservation.asset_reservation_objects
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-tab-item",
                  { attrs: { value: "associatedObjects" } },
                  [
                    _c("reservation-objects-table", {
                      attrs: {
                        "asset-reservation-objects":
                          _vm.assetReservation.asset_reservation_objects,
                        loading: _vm.loading
                      },
                      on: { "open-asset": _vm.openAsset }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b18bbca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b18bbca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssetReservationManagement/Data/ReservationDetails.vue
// module id = null
// module chunks = 